 
 
    <h2 class="text-xl font-bold mb-4 text-gray-800">Add New Task</h2>
    <form (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="mb-4">
        <label class="block text-sm font-semibold mb-1 text-gray-700" for="title">Title</label>
        <input
          type="text"
          id="title"
          [(ngModel)]="newProjectTask.title"
          name="title"
          required
          class="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-200"
        />
      </div>
      <div class="mb-4">
        <label class="block text-sm font-semibold mb-1 text-gray-700" for="description">Description</label>
         <textarea
          id="description"
          [(ngModel)]="newProjectTask.description"
          name="description"
          required
          rows="3"
          class="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-200 resize-y"
        ></textarea>
      </div>
      <div class="mb-6">
        <label class="block text-sm font-semibold mb-1 text-gray-700" for="dueDate">Due Date</label>
        <input
          type="date"
          id="dueDate"
          [(ngModel)]="newProjectTask.dueDate"
          name="dueDate"
          required
          class="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-200"
        />
      </div>
      <button
        type="submit"
        class="w-full py-2 bg-blue-600 text-white rounded font-semibold hover:bg-blue-700 transition"
      >
        Add Task
      </button>
    </form>
 
 
